import type { TealiumEventType as TealiumEvent } from '@tuic/tracking';

export {
  EventClickAttributes,
  EventClickArea,
  EventClickElement,
} from '@tuic/tracking';
export type {
  EventData,
  TealiumLinkDataObject,
  PageViewData,
  TealiumViewDataObject,
} from '@tuic/tracking';
export type { TealiumEvent };
